import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import {
  isFieldWrong,
  isFormValid
} from "../../common/lib/validationAllFields";
import {
  addNotificationsForInvalidFields,
  focusInvalidField
} from "../lib/validationWeb";
import Spinner from "../components/spinner.react";
import InputWithError from "../components/inputWithError.react";
import Modal from "../components/modal.react";
import Table from "./table.react";
import Pagination from "../components/pagination/pagination.react";
import { Link } from "react-router";
import InputSearch from "../components/inputSearch.react";

export default class PagesList extends Component {
  static propTypes = {
    msg: React.PropTypes.object
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { actions } = this.props;
    actions.resetPageListPagination();
    actions.setSearchField("pagesLists", "name", "");
    this.loadPagesList(true);
  }

  componentDidUpdate(prevProps) {
    const {
      params: { slug },
      actions,
      pageTranslations: { forms: { createPageTranslation: { fields } } }
    } = this.props;
    const {
      params: { slug: prevSlug },
      pageTranslations: {
        forms: { createPageTranslation: { fields: prevFields } }
      }
    } = prevProps;

    if (prevSlug !== slug) {
      actions.setSearchField("pagesLists", "name", "");
      this.loadPagesList(true);
    }

    if (fields.get("name") !== prevFields.get("name")) {
      actions.setFormField(
        "pageTranslations",
        "createPageTranslation",
        "slug",
        this.generateSlug(fields.get("name"))
      );
    }
  }

  generateSlug = name => {
    name = name.replace(/^\s+|\s+$/g, ""); // trim
    name = name.toLowerCase();

    const from = "àáäâąæãåāèéëêęėēìíïîòóöôóõœøōùúüûñçćčśßšłżźžń·/_,:;";
    const to = "aaaaaaaaaeeeeeeeiiiiooooooooouuuuncccssslzzzn------";
    for (var i = 0, l = from.length; i < l; i++) {
      name = name.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
    }

    name = name
      .replace(/[^a-z0-9 -]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");

    return name;
  };

  loadPagesList = resetPageListPagination => {
    const {
      actions,
      notificationSystem,
      params: { slug },
      locales: { locales: { defaultLocale } },
      pagesLists: { pagesLists: { singleListMeta, search: searchObj, sort } }
    } = this.props;

    if (resetPageListPagination) {
      actions.resetPageListPagination();
      actions.clearForm("pagesLists", "createPagesList");
      actions
        .getPagesListBySlug(
          slug,
          {
            all: 0,
            count: 0,
            limit: 10,
            currentPage: 0
          },
          searchObj,
          sort
        )
        .then(({ error, payload }) => {
          if (error) {
            addNotificationsForInvalidFields(payload, notificationSystem);
          }
        });
    } else {
      actions.clearForm("pagesLists", "createPagesList");
      actions
        .getPagesListBySlug(slug, singleListMeta, searchObj, sort)
        .then(({ error, payload }) => {
          if (error) {
            addNotificationsForInvalidFields(payload, notificationSystem);
          }
        });
    }
  };

  setGroup = value => {
    const { actions } = this.props;
    actions.setFormField("users", "createUser", "groupName", value);
  };

  openAddPageTranslationModal = () => {
    const { actions } = this.props;
    actions.setIsAddPageTranslationModalVisible(true);
  };

  closeAddPageTranslationModal = () => {
    const { actions } = this.props;
    actions.setIsAddPageTranslationModalVisible(false);
  };

  prepareNewPageTranslation = slugIndex => {
    const {
      params: { slug },
      pagesLists: { pagesLists: { entities: pagesLists } },
      pageTranslations: { forms: { createPageTranslation: { fields } } },
      locales: { locales: { defaultLocale } }
    } = this.props;
    const data = {
      locale: defaultLocale,
      name: fields.get("name"),
      slug:
        slugIndex !== 0
          ? `${fields.get("slug")}-${slugIndex}`
          : fields.get("slug"),
      sort: fields.get("sort"),
      pageListUID: pagesLists.getIn([slug, "uid"])
    };
    return data;
  };

  createPageTranslation = slugIndex => {
    const { notificationSystem, actions } = this.props;
    slugIndex = typeof slugIndex === "number" ? slugIndex : 0;
    actions
      .createPagesTranslation(this.prepareNewPageTranslation(slugIndex))
      .then(({ error, payload }) => {
        if (error) {
          if (payload.errors.slug) {
            this.createPageTranslation(slugIndex + 1);
          }
          addNotificationsForInvalidFields(payload, notificationSystem);
          return false;
        } else {
          this.loadPagesList(true);
          return true;
        }
      });
    actions.setIsAddPageTranslationModalVisible(false);
  };

  paginationAction = page => {
    const {
      actions,
      notificationSystem,
      params: { slug },
      pagesLists: { pagesLists: { singleListMeta, search, sort } }
    } = this.props;
    actions.setPageListPaginationPage(page);
    let meta = singleListMeta.toJS();
    meta.currentPage = page;
    actions
      .getPagesListBySlug(slug, meta, search, sort)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        }
      });
  };

  searchAction = () => {
    const { actions } = this.props;
    actions.setPageListPaginationPage(0);
    this.loadPagesList();
  };

  render() {
    const {
      actions,
      pageTranslations: { forms },
      msg: { pageTranslations: msg },
      params: { slug },
      pagesLists: {
        pagesLists: { entities: pagesLists, singleListMeta, search: searchObj }
      }
    } = this.props;

    const createPageTranslationFormProps = {
      feature: "pageTranslations",
      actions: actions,
      form: forms.createPageTranslation,
      formName: "createPageTranslation",
      msg: msg.forms.createPageTranslation,
      validateFormField: actions.validateFormFieldPagesTranslations
    };

    const searchProps = {
      searchObj: searchObj,
      actions: actions,
      getDataFromServerAction: this.searchAction,
      feature: "pagesLists"
    };

    return (
      <div className="islogged-page">
        <div className="row middle-xs">
          <h2 className="col-xs-8">{pagesLists.getIn([slug, "name"])}</h2>
          <div className="col-xs-4">
            <button className="info" onClick={this.openAddPageTranslationModal}>
              dodaj wpis
            </button>
            <Link to={`/pagesLists/${slug}/categories`}>
              <button className="info">przeglądaj kategorie</button>
            </Link>
          </div>
          <div className="col-xs-12">
            <div className="box-wrapper">
              <div className="title">
                <div className="row middle-xs">
                  <div className="col-xs-8">Wszystkie wpisy</div>
                  <div className="col-xs-4">
                    <div className="row middle-xs">
                      <div className="col-xs-12">
                        <InputSearch {...searchProps} field="name" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="content-wrapper">
                <Table {...this.props} tableWidth={1000} tableHeight={300} />
                <Pagination
                  numberOfPages={Math.ceil(
                    singleListMeta.all / singleListMeta.limit
                  )}
                  setPageAction={this.paginationAction}
                  maxPagesDisplay={5}
                  currentPage={singleListMeta.currentPage + 1}
                />
              </div>
            </div>
          </div>
        </div>

        {forms.createPageTranslation.isAddModalVisible && (
          <Modal
            closeModalAction={this.closeAddPageTranslationModal}
            enterAction={this.createPageTranslation}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs">
              <h3>Utwórz nowy wpis:</h3>
              <div className="col-xs-12">
                <InputWithError
                  placeholder="Nazwa"
                  field="name"
                  {...createPageTranslationFormProps}
                />
              </div>
              <div className="col-xs-12">
                <InputWithError
                  placeholder="slug"
                  field="slug"
                  {...createPageTranslationFormProps}
                />
              </div>
              <button
                className="success"
                onTouchTap={this.createPageTranslation}
              >
                Tak
              </button>
              <button
                className="error"
                onTouchTap={this.closeAddPageTranslationModal}
              >
                Nie
              </button>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/pagesList/pagesList.react.js